import { Header } from "../components/hercode/header" 
import { Hero } from "../components/hercode/hero"
import { About } from "../components/hercode/about"
import { Problems } from "../components/hercode/problems"
import { Process } from "../components/hercode/process"
import { CTA } from "../components/hercode/cta"
import { Contact } from "../components/hercode/contact"
import { Footer } from "../components/hercode/footer"

export default function HercodeLandingPage() {
  return (
    <div className="min-h-screen bg-background">
      <Header />
      <main>
        <Hero />
        <About />
        <Problems />
        <Process />
        <CTA />
        <Contact />
      </main>
      <Footer />
    </div>
  )
}
